import { useStore } from "../../store/store";
import s from "./Terms.module.scss";

const Terms = () => {
  const setIsHoveringTerms = useStore((state) => state.setIsHoveringTerms);

  const onEnter = () => {
    setIsHoveringTerms(true);
  };

  const onLeave = () => {
    setIsHoveringTerms(false);
  };

  return (
    <a
      href="https://diorbystarck.art/legal-terms-and-privacy/"
      className={s.terms}
      onMouseEnter={() => onEnter()}
      onMouseLeave={() => onLeave()}
    >
      Legal terms & privacy
    </a>
  );
};

export default Terms;
